import { createContext, useContext } from 'react'
import { Socket } from 'socket.io-client'

export interface SocketContextType {
	socket: Socket | null
	isConnected: boolean
	/** Holds the trip's room for a surface; the socket joins it for the first holder, and again after a reconnect. */
	joinTrip: (tripId: string) => void
	/** Lets go of a held room; the socket leaves it when the last holder goes. */
	leaveTrip: (tripId: string) => void
	/** Hold incoming realtime invalidations until the returned release is called — for the length of a drag, never a page. */
	holdRealtime: () => () => void
}

export const SocketContext = createContext<SocketContextType | undefined>(undefined)

export const useSocket = (): SocketContextType => {
	const context = useContext(SocketContext)
	if (context === undefined) {
		throw new Error('useSocket must be used within a SocketProvider')
	}
	return context
}
